// import { combineReducers } from "redux";
import graphReducer from "./graphReducer";
// import mouseReducer from "./mouseReducer";
// import controlReducer from "./controlReducer";

export default graphReducer;
